export const SEARCH = 'SEARCH'
export const SEARCH_SUCCESS = 'SEARCH_SUCCESS'
export const SEARCH_ERROR = 'SEARCH_ERROR'

export const PREDICATE_CHANGE = 'PREDICATE_CHANGE'
export const PREDICATE_VALUE_CHANGE = 'PREDICATE_VALUE_CHANGE'
export const PREDICATE_ADD = 'PREDICATE_ADD'
export const PREDICATE_REMOVE = 'PREDICATE_REMOVE'

export const UPDATE_QUERY = 'UPDATE_QUERY'



/** WEBPACK FOOTER **
 ** ./src/constants.js
 **/